const initialState = {
    pending: false,
    fieldGroups: [],
    page: 0,
    itemsCount: 0,
    pageCount: 0,
    error: null,
    selected: {}
};

const fieldGroupsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_FIELD_GROUPS_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_FIELD_GROUPS_SUCCESS':
            return {
                ...state,
                pending: false,
                fieldGroups: action.fieldGroups
            };
        case 'GET_FIELD_GROUPS_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'SELECT_FIELD_GROUP':
            return {
                ...state,
                selected: action.selected
            };
        default:
            return state;
    }
};

export default fieldGroupsReducer;
